module.exports = __webpack_public_path__ + "files/d459632ec35250277328388039edc45d.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Fraktur-Regular.ttf
// module id = 1421
// module chunks = 59